import { createFileRoute } from "@tanstack/react-router";
import { ListDomains, EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/domains/")({
  component: () => (
    <EditContent fullWidth>
      <ListDomains />
    </EditContent>
  ),
});

export { Route };
